const PreferenceKey = {
    accessToken: "chatbotAccessToken",
    refreshToken: "chatbotRefreshToken"
}
export default PreferenceKey